
<section class="ui_svgicon">
    <svg class="svg-icon" v-if="type === 'svg'">
      <use :xlink:href="`#${iconClass}`"></use>
    </svg>
</section>

